import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageContext.jsx';

const PasswordInput = ({ value, onChange, onKeyPress }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const { t } = useLanguage();
  const actionLabel = isPasswordVisible ? t('login.hidePassword') : t('login.showPassword');

  return (
    <div className="mb-6">
      <label htmlFor="login-password" className="block text-sm font-semibold text-neutral-600 mb-3 ml-2">
        {t('login.password')}
      </label>
      <div className="relative bg-white rounded-2xl border-2 border-gray-200 focus-within:border-primary focus-within:shadow-[0_0_0_4px_rgba(0,90,224,0.1)] transition-all duration-200">
        <input
          id="login-password"
          type={isPasswordVisible ? 'text' : 'password'}
          className="w-full h-14 pl-5 pr-14 text-base text-neutral-600 bg-transparent border-none outline-none placeholder-neutral-400 rounded-2xl"
          placeholder="••••••••"
          value={value}
          onChange={(e) => onChange('password', e.target.value)}
          onKeyPress={onKeyPress}
          autoComplete="current-password"
        />
        <button
          type="button"
          onClick={() => setIsPasswordVisible((visible) => !visible)}
          onMouseDown={(event) => event.preventDefault()}
          className="absolute inset-y-0 right-2 my-auto flex h-10 w-10 items-center justify-center rounded-xl text-neutral-400 transition-colors hover:bg-blue-50 hover:text-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
          aria-label={actionLabel}
          aria-pressed={isPasswordVisible}
          title={actionLabel}
        >
          {isPasswordVisible ? <EyeOff className="h-5 w-5" aria-hidden="true" /> : <Eye className="h-5 w-5" aria-hidden="true" />}
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;
